import { render, staticRenderFns } from "./ModuleNewsletterModelProducts.vue?vue&type=template&id=2335a505"
import script from "./ModuleNewsletterModelProducts?vue&type=script&lang=ts&external"
export * from "./ModuleNewsletterModelProducts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports